import { render, staticRenderFns } from "./RequireVersion.vue?vue&type=template&id=89fd7420&scoped=true&"
import script from "./RequireVersion.vue?vue&type=script&lang=js&"
export * from "./RequireVersion.vue?vue&type=script&lang=js&"
import style0 from "./RequireVersion.vue?vue&type=style&index=0&id=89fd7420&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fd7420",
  null
  
)

export default component.exports